import { render } from "./ProductsQuantity.vue?vue&type=template&id=bdc28f58"
import script from "./ProductsQuantity.vue?vue&type=script&scoped=true&lang=js"
export * from "./ProductsQuantity.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__